import React from 'react';
import {
  EventsTable,
  EventYearFilter,
  withEventYearFilterContext,
} from 'components/Events';
import { useGetRegistrationUserEvents } from 'components/Events/gql';
import { SearchableListContainer } from 'components/SearchableListContainer';

export const TrackRegistrationsEventsDesktop = withEventYearFilterContext(
  () => {
    const { data } = useGetRegistrationUserEvents();

    const events = data?.getRegistrationEventsByAccount?.results ?? [];
    const count = data?.getRegistrationEventsByAccount?.count ?? 0;

    return (
      <SearchableListContainer
        pageCount={count}
        paginated
        searchInputPlaceholder="Search Events"
        title="Registrations"
        titleBarContent={<EventYearFilter />}
      >
        <EventsTable events={events} listType="registrations" />
      </SearchableListContainer>
    );
  }
);
